import React  from 'react';
import Home from './pages/Home';
import GlobalStyle from './styles/global';


function App() {
  

  return (
    <>
      <GlobalStyle />
      <Home />

    </>
  );
}

export default App;
